import { render } from "./list.vue?vue&type=template&id=025298fe&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=025298fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-025298fe"

export default script